<template>
  <div className="summary">
    <h2>Movies you watched</h2>
    <div>
      <p>
        <span class="iconClass"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            stroke="#aad3f3"
            fill="#aad3f3"
            viewBox="0 0 640 640"
          >
            <path
              d="M278.7 64.7C296 68.4 307 85.4 303.3 102.7L284.2 192L410.7 192L432.7 89.3C436.4 72 453.4 61 470.7 64.7C488 68.4 499 85.4 495.3 102.7L476.2 192L544 192C561.7 192 576 206.3 576 224C576 241.7 561.7 256 544 256L462.4 256L435 384L502.8 384C520.5 384 534.8 398.3 534.8 416C534.8 433.7 520.5 448 502.8 448L421.2 448L399.2 550.7C395.5 568 378.5 579 361.2 575.3C343.9 571.6 332.9 554.6 336.6 537.3L355.7 448L229.2 448L207.2 550.7C203.5 568 186.5 579 169.2 575.3C151.9 571.6 140.9 554.6 144.6 537.3L163.8 448L96 448C78.3 448 64 433.7 64 416C64 398.3 78.3 384 96 384L177.6 384L205 256L137.2 256C119.5 256 105.2 241.7 105.2 224C105.2 206.3 119.5 192 137.2 192L218.8 192L240.8 89.3C244.4 72 261.4 61 278.7 64.7zM270.4 256L243 384L369.5 384L396.9 256L270.4 256z"
            />
          </svg>
        </span>
        <span>{{ watched.length }} movies</span>
      </p>
      <p>
        <span class="iconClass"><Star :full="true" /></span>
        <span>{{ avgImdbRating.toFixed(2) }}</span>
      </p>
      <p>
        <span class="iconClass"><Star :full="true" /></span>
        <span>{{ avgUserRating.toFixed(2) }}</span>
      </p>
      <p>
        <span class="iconClass">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#aad3f3"
            stroke="aad3f3"
            viewBox="0 0 640 640"
          >
            <path
              d="M320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z"
            />
          </svg>
        </span>
        <span>{{ avgRuntime.toFixed(2) }} min</span>
      </p>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue';
import Star from '../Star.vue';

export default {
  props: ['watched'],
  components: {
    Star,
  },
  setup(props) {
    const average = (arr) =>
      arr.reduce((acc, cur, i, arr) => acc + cur / arr.length, 0);

    const avgImdbRating = computed(() =>
      average(props.watched.map((movie) => movie.imdbRating))
    );
    const avgUserRating = computed(() =>
      average(props.watched.map((movie) => movie.userRating))
    );
    const avgRuntime = computed(() =>
      average(props.watched.map((movie) => movie.Runtime))
    );

    return {
      average,
      avgImdbRating,
      avgUserRating,
      avgRuntime,
    };
  },
};
</script>
